import { forwardRef, memo, ReactNode } from 'react';
import classes from 'classnames';
import styles from './Card.module.scss';

export type Props = {
  children: ReactNode;
  className?: string;
  dataTest?: string;
};

export default memo(
  forwardRef<HTMLDivElement, Props>(function Card(
    { children, className, dataTest = 'component-card' },
    ref,
  ) {
    return (
      <div
        ref={ref}
        data-test={dataTest}
        className={classes(styles.card, className)}
      >
        {children}
      </div>
    );
  }),
);
